import classNames from 'classnames';
import styles from './project-sharing.module.less';
import RoundedButtonSecondary from '../../components/button/rounded-button-secondary/RoundedButtonSecondary';

export const MarkAsCompleteButton = ({ onClick, completed }) => {
    return (
        <RoundedButtonSecondary
            disabled={completed}
            onClick={onClick}
            className={classNames(styles.markAsCompleteButton, { [styles.completed]: completed })}
        >
            <div className={styles.sharingStatus}>
                <div className={completed ? styles.checkmarkBackground : styles.checkmarkBackgroundNotComplete}>
                    <i className={`fa-solid fa-check ${styles.checkmarkIcon}`} aria-hidden="true" />
                </div>
            </div>
            {completed ? 'Fullført' : 'Marker som fullført'}
        </RoundedButtonSecondary>
    );
};
